export default "/assets/Icon/Dot.svg"